export const SET_LOADING = 'SET_LOADING';
export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const FETCH_LOCATIONS_SUCCESS = 'FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATION_SUCCESS = 'FETCH_LOCATION_SUCCESS';
export const CREATE_LOCATION_SUCCESS = 'CREATE_LOCATION_SUCCESS';
export const UPDATE_LOCATION_SUCCESS = 'UPDATE_LOCATION_SUCCESS';
export const DELETE_LOCATION_SUCCESS = 'DELETE_LOCATION_SUCCESS';

export const FETCH_EMPLOYER_SUCCESS = 'FETCH_EMPLOYER_SUCCESS';
export const UPDATE_EMPLOYER_SUCCESS = 'UPDATE_EMPLOYER_SUCCESS';
export const GET_EMPLOYER_LOGO_SUCCESS = 'GET_EMPLOYER_LOGO_SUCCESS';

export const FETCH_EMPLOYEE_SUCCESS = 'FETCH_EMPLOYEE_SUCCESS';
export const UPDATE_EMPLOYEE_SUCCESS = 'UPDATE_EMPLOYEE_SUCCESS';
export const CREATE_EMPLOYEE_SUCCESS = 'CREATE_EMPLOYEE_SUCCESS';

// Nova funcionalidade
export const FETCH_TASK_SCHEDULES_SUCCESS = 'FETCH_TASK_SCHEDULES_SUCCESS';
export const UPDATE_TASK_SCHEDULES_SUCCESS = 'UPDATE_TASK_SCHEDULES_SUCCESS';

export const FETCH_DISMISS_EMPLOYEE_SUCCESS = 'FETCH_DISMISS_EMPLOYEE_SUCCESS';

export const FETCH_EMPLOYEES_SUCCESS = 'FETCH_EMPLOYEES_SUCCESS';
export const DELETE_EMPLOYEE_SUCCESS = 'DELETE_EMPLOYEE_SUCCESS';

export const FETCH_SCHEDULES_SUCCESS = 'FETCH_SCHEDULES_SUCCESS';
export const DELETE_SCHEDULE_SUCCESS = 'DELETE_SCHEDULE_SUCCESS';
export const UPDATE_SCHEDULE_NAME_SUCCESS = 'UPDATE_SCHEDULE_NAME_SUCCESS';

export const FETCH_OFFICES_SUCCESS = 'FETCH_OFFICES_SUCCESS';
export const CREATE_OFFICE_SUCCESS = 'CREATE_OFFICE_SUCCESS';
export const UPDATE_OFFICE_SUCCESS = 'UPDATE_OFFICE_SUCCESS';
export const DELETE_OFFICE_SUCCESS = 'DELETE_OFFICE_SUCCESS';

export const FETCH_DEPARTMENTS_SUCCESS = 'FETCH_DEPARTMENTS_SUCCESS';
export const FETCH_DEPARTMENT_SUCCESS = 'FETCH_DEPARTMENT_SUCCESS';
export const CREATE_DEPARTMENT_SUCCESS = 'CREATE_DEPARTMENT_SUCCESS';
export const UPDATE_DEPARTMENT_SUCCESS = 'UPDATE_DEPARTMENT_SUCCESS';
export const DELETE_DEPARTMENT_SUCCESS = 'DELETE_DEPARTMENT_SUCCESS';

export const FETCH_SETS_SUCCESS = 'FETCH_SETS_SUCCESS';
export const CREATE_SETS_SUCCESS = 'CREATE_SETS_SUCCESS';
export const UPDATE_SETS_SUCCESS = 'UPDATE_SETS_SUCCESS';
export const DELETE_SETS_SUCCESS = 'DELETE_SETS_SUCCESS';

export const APPLY_RESTRICTIONS_SUCCESS = 'APPLY_RESTRICTIONS_SUCCESS';

export const FETCH_TIMECLOCKS_SUCCESS = 'FETCH_TIMECLOCKS_SUCCESS';
export const DELETE_TIMECLOCK_SUCCESS = 'DELETE_TIMECLOCK_SUCCESS';
export const UPDATE_SELECTED_START_DATE_SUCCESS = 'UPDATE_SELECTED_START_DATE_SUCCESS';
export const UPDATE_SELECTED_END_DATE_SUCCESS = 'UPDATE_SELECTED_END_DATE_SUCCESS';

export const FETCH_EXTRA_HOURS_RANK_SUCCESS = 'FETCH_EXTRA_HOURS_RANK_SUCCESS';
export const FETCH_EMPLOYEE_LOCATIONS_SUCCESS = 'FETCH_EMPLOYEE_LOCATIONS_SUCCESS';
export const FETCH_HOURS_SUCCESS = 'FETCH_HOURS_SUCCESS';
export const FETCH_DELAY_SUCCESS = 'FETCH_DELAY_SUCCESS';
export const FETCH_ABSENCES_SUCCESS = 'FETCH_ABSENCES_SUCCESS';
export const FETCH_DELAYEDES_SUCCESS = 'FETCH_DELAYEDES_SUCCESS';

export const FETCH_HOLIDAYS_SUCCESS = 'FETCH_HOLIDAYS_SUCCESS';
export const CREATE_HOLIDAY_SUCCESS = 'CREATE_HOLIDAY_SUCCESS';
export const DELETE_HOLIDAY_SUCCESS = 'DELETE_HOLIDAY_SUCCESS';

export const UPDATE_VACATION_SUCCESS = 'UPDATE_VACATION_SUCCESS';
export const CREATE_VACATION_SUCCESS = 'CREATE_VACATION_SUCCESS';
export const DELETE_VACATION_SUCCESS = 'DELETE_VACATION_SUCCESS';
export const FETCH_VACATIONS_SUCCESS = 'FETCH_VACATIONS_SUCCESS';

export const FETCH_BALANCE_HOURS_SUCCESS = 'FETCH_BALANCE_HOURS_SUCCESS';
export const UPDATE_BALANCE_HOUR_START = 'UPDATE_BALANCE_HOUR_START';
export const UPDATE_BALANCE_HOUR_END = 'UPDATE_BALANCE_HOUR_END';
export const UPDATE_BALANCE_HOUR_SUCCESS = 'UPDATE_BALANCE_HOUR_SUCCESS';

export const FETCH_BANK_HOURS_SUCCESS = 'FETCH_BANK_HOURS_SUCCESS';
export const CREATE_BANK_HOUR_SUCCESS = 'UPDATE_BANK_HOUR_SUCCESS';
export const UPDATE_BANK_HOUR_SUCCESS = 'UPDATE_BANK_HOUR_SUCCESS';
export const DELETE_BANK_HOUR_SUCCESS = 'DELETE_BANK_HOUR_SUCCESS';

export const FETCH_EXTRA_HOURS_SUCCESS = 'FETCH_EXTRA_HOURS_SUCCESS';
export const CREATE_EXTRA_HOUR_SUCCESS = 'CREATE_EXTRA_HOUR_SUCCESS';
export const UPDATE_EXTRA_HOUR_SUCCESS = 'UPDATE_EXTRA_HOUR_SUCCESS';
export const DELETE_EXTRA_HOUR_SUCCESS = 'DELETE_EXTRA_HOUR_SUCCESS';

export const FETCH_STATES_SUCCESS = 'FETCH_STATES_SUCCESS';
export const FETCH_CITIES_SUCCESS = 'FETCH_CITIES_SUCCESS';
export const FETCH_ADDRESS_SUCCESS = 'FETCH_ADDRESS_SUCCESS';

export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_START = 'FETCH_USER_START';
export const FETCH_USER_END = 'FETCH_USER_END';
export const CLOCK_IN_OUT_SUCCESS = 'CLOCK_IN_OUT_SUCCESS';

export const FETCH_DIVERGENCE_SUCCESS = 'FETCH_DIVERGENCE_SUCCESS';
export const EDIT_DIVERGENCE_SUCCESS = 'EDIT_DIVERGENCE_SUCCESS';
export const VALIDATE_DIVERGENCE_SUCCESS = 'VALIDATE_DIVERGENCE_SUCCESS';

export const FETCH_HOURSSETS_SUCCESS = 'FETCH_HOURSSETS_SUCCESS';

export const FETCH_BANK_OF_HOURS_SUCCESS = 'FETCH_BANK_OF_HOURS_SUCCESS';

